<div class="search-box">
  <input
    #searchInput
    type="text"
    [placeholder]="placeholder"
    (keyup.enter)="submit(searchInput.value)" />
  <button type="button" class="search-box__submit" (click)="submit(searchInput.value)">
    <lucide-icon name="Search" size="16"></lucide-icon>
    <span>Search</span>
  </button>
</div>
